import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class ControlResetService
{
    public static resetControl(control: AbstractControl, initialValue?: any) {
        if (initialValue !== null) {
            control.setValue(initialValue);
        } else {
            control.setValue('');
        }
        control.markAsUntouched({});
        control.markAsPristine({});
    }
}
